import { memo, useMemo } from 'react';

import type { MarketplaceBrowseMapMarkers } from 'components/marketplace/browse/marketplaceBrowse';
import type { LikedPropertyIds } from 'components/marketplace/types';

import { MarketplaceMapMarker } from './MarketplaceMapMarker';

interface MarketplaceMapMarkersProps {
  markers?: MarketplaceBrowseMapMarkers | null;
  likedPropertyIds?: LikedPropertyIds;
  selectedAddressId?: string;
  loadingAddressId?: string | null;
  onListingClick: (addressId: string) => void;
}

export const MarketplaceMapMarkers = memo(
  ({
    markers,
    likedPropertyIds,
    selectedAddressId,
    loadingAddressId,
    onListingClick,
  }: MarketplaceMapMarkersProps) => {
    const sortedMarkers = useMemo(() => {
      if (!markers) {
        return undefined;
      }
      // oxlint-disable-next-line unicorn/no-array-sort -- Cosmos still targets browsers without Array.prototype.toSorted.
      return [...markers].sort((a, b) => b.location.latitude - a.location.latitude);
    }, [markers]);

    return sortedMarkers?.map((listing) => (
      <MarketplaceMapMarker
        key={listing.addressId}
        property={listing}
        handleFetchPropertyDetails={onListingClick}
        isLiked={likedPropertyIds?.has(listing.addressId) ?? false}
        isSelected={listing.addressId === selectedAddressId}
        isLoading={listing.addressId === loadingAddressId}
      />
    ));
  },
);

MarketplaceMapMarkers.displayName = 'MarketplaceMapMarkers';
